import { Box, Link, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import moment from "moment";
import StatusComponent from "../../../components/StatusComponent";
import styles from "./Task.module.scss";
import { ITaskHeader } from "../../../models/task.model";
import { useTranslation } from "react-i18next";
import DocumentDownload from "../../../components/DocumentDownload";

interface Props {
  taskHeader: ITaskHeader;
  loader: (loading: boolean) => void;
}

const TaskHeader: React.FC<Props> = ({ taskHeader, loader }) => {
  const { t } = useTranslation();
  const showAddComments = taskHeader.status === "Pending" && taskHeader.type === "ColleagueReview";

  const buildDuedateLegend = () => {
    if (!taskHeader.deadline) return "";

    const today = moment().endOf("day");
    if (today.isAfter(taskHeader.deadline, "day")) {
      const overdue = today.diff(taskHeader.deadline, "day");
      return t("daysOverdue", { days: overdue });
    }

    return "";
  };

  return (
    <Box className={styles.taskHeader}>
      <p>
        <strong>{t("publicationTicketNumber")}: </strong>
        {taskHeader?.ticketNumber}
      </p>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell className={styles.title}>{t("title")}</TableCell>
            <TableCell className={styles.createdBy}>{t("createdBy")}</TableCell>
            <TableCell className={styles.createdDate}>{t("createdDate")}</TableCell>
            <TableCell className={styles.deadline}>{t("deadline")}</TableCell>
            <TableCell className={styles.description}>{t("description")}</TableCell>
            <TableCell className={styles.status}>{t("status")}</TableCell>
            <TableCell className={styles.download}>{t("download")}</TableCell>
            {showAddComments && <TableCell className={styles.openOnline}>{t("openOnline")}</TableCell>}
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell className={styles.title}>{taskHeader?.title}</TableCell>
            <TableCell className={styles.createdBy}>{taskHeader?.createdBy}</TableCell>
            <TableCell className={styles.createdDate}>{moment(taskHeader?.createdDate).format("MM/DD/YYYY")}</TableCell>
            <TableCell className={styles.deadline}>
              <strong>
                <p>
                  {taskHeader?.deadline && moment(taskHeader?.deadline).format("MM/DD/YYYY")}
                  <strong>{buildDuedateLegend()}</strong>
                </p>
              </strong>
            </TableCell>
            <TableCell className={styles.description}>
              <p>{taskHeader?.abstract}</p>
            </TableCell>
            <TableCell className={styles.status}>
              <StatusComponent text={taskHeader?.publicationStatus || ""} />
            </TableCell>
            <TableCell className={styles.download}>
              {taskHeader.draft && <DocumentDownload documentId={taskHeader.draft?.id} />}
              {taskHeader.finalVersions && <DocumentDownload documents={taskHeader.finalVersions} />}
            </TableCell>
            {showAddComments && (
              <TableCell className={styles.openOnline}>
                <Link href={taskHeader.draft?.link} variant="button" target="_blank" rel="noopener noreferrer">
                  {t("addCommentsOnline")}
                </Link>
              </TableCell>
            )}
          </TableRow>
        </TableBody>
      </Table>
    </Box>
  );
};

export default TaskHeader;
